import { useContext } from "react";
import { IIonScreenAuthContext, IonScreenAuthContext } from "../IonScreenAuthContext";

export const useIonScreenAuth = (): IIonScreenAuthContext => useContext(IonScreenAuthContext);